import React from 'react'
import YoutubeAdPreview from './YoutubeAdPreview';

const YoutubeAdsetForm = ({ dataItem, onChange }) => {
    const videoId = dataItem?.ad?.creatives?.length > 0 ? dataItem?.ad?.creatives[0]?.url : null;
    return (
        <div className='row mt-2 p-2' style={{ minHeight: "260px" }}>
            <div className='col-7 border-end pr-4'>
                <div className="row g-3">
                    <div className="col-6">
                        <label className="fw-semibold text-secondary small mb-1" htmlFor="actionHeadline">Action Headline *</label>
                        <input
                            type="text"
                            name="actionHeadline"
                            placeholder="Enter Call-to-action Headline"
                            className="form-control form-control-sm shadow-sm"
                            value={dataItem.actionHeadline}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-6">
                        <label className="fw-semibold text-secondary small mb-1" htmlFor="actionButtonLabel">Action Button Label *</label>
                        <input
                            type="text"
                            name="actionButtonLabel"
                            placeholder="e.g. Learn More, Subscribe"
                            className="form-control form-control-sm shadow-sm"
                            value={dataItem.actionButtonLabel}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <label className="fw-semibold text-secondary small mb-1" htmlFor="finalUrls">Final URL *</label>
                        <input
                            type="text"
                            name="finalUrls"
                            placeholder="Enter Landing Page URL"
                            className="form-control form-control-sm shadow-sm"
                            value={dataItem.finalUrls}
                            onChange={onChange}
                        />
                        <small className="form-text text-muted">Destination website where users land after clicking the ad.</small>
                    </div>
                </div>
            </div>
            <div className='col-5 pl-4 d-flex align-items-center justify-content-center'>
                <div className="w-100">
                    <YoutubeAdPreview videoId={videoId} actionHeadline={dataItem?.actionHeadline} actionButtonLabel={dataItem?.actionButtonLabel} finalUrls={dataItem?.finalUrls ? dataItem?.finalUrls?.split(',').map(s => s.trim()).filter(Boolean) : []} />
                </div>
            </div>
        </div>
    )
}

export default YoutubeAdsetForm;